<section [ngClass]="{ minimized: !isAsideCollapsible }">
  <ng-content select="div"></ng-content>
</section>
<section>
  <ng-content select="aside"></ng-content>
</section>
